// extracted by mini-css-extract-plugin
module.exports = {"loader":"CircularProgress_loader__Jty8t","spin":"CircularProgress_spin__1aD_1","track":"CircularProgress_track__MaXkj","progress":"CircularProgress_progress__u3xIF"};